<script setup lang="ts">
import type { QuoteDocument } from "@kekkle/shared/types/documents/quote-document/quote-document";
import KekkleBottomSheet from "@/components/ui/KekkleBottomSheet.vue";
import Quote from "@/components/Quote.vue";

type QuoteWithMetadata = QuoteDocument & {
  reported_by?: string[] | null;
  number_of_comments?: number;
};

type Props = {
  quoteData: QuoteWithMetadata | null;
};

defineProps<Props>();

const open = defineModel<boolean>("open", { required: true });

const emit = defineEmits<{
  (e: "goToComments", payload: { quoteId: string; groupId: string }): void;
}>();

function handleGoToComments(payload: { quoteId: string; groupId: string }) {
  open.value = false;
  emit("goToComments", payload);
}
</script>

<template>
  <KekkleBottomSheet v-model:open="open" shadow="red" skip-history-cleanup>
    <Quote
      v-if="quoteData"
      :quote-data="quoteData"
      :quote-id="quoteData._id"
      @go-to-comments="handleGoToComments"
    />
  </KekkleBottomSheet>
</template>
